module.exports = __webpack_public_path__ + "img/vetvise_logo.ca1f50d9.svg";